import { useEffect, useRef, useState } from 'react';
import { getCurrentDateTime, request, toast } from '../../../../../../utils';
import { IconButton, Stack, Typography, TextField as MuiTextField,Radio } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Table } from '../../../../../../components';

const TABLE_HEADER = [
  { header: 'IPD No.', accessor: 'ipd_no' },
  { header: 'UHID No.', accessor: 'uhid' },
  { header: 'Bill No.', accessor: (row)=> row?.finalbill?.bill_no },
  { header: 'Patient Name', accessor: (row) => `${row.patient.first_name} ${row.patient.last_name}` },
  { header: 'Admission Date', accessor: (row) => `${getCurrentDateTime('date', row.admissionDate)}` },
  { header: 'Address', accessor: 'patient.address.address' },
  { header: 'Sponsor', accessor: 'patient.sponsor.name' },
  { header: 'Mobile No.', accessor: 'patient.address.mobile' }
];

const initialIndoorRegisterationDataObj = {
    data: [],
    loading: false
  };

export const IPDSearchHandlerAllBillManagement = ({ onClose, onAdd ,setSelectedRow}) => {
  const [input, setInput] = useState('');
  const [patientData, setPatientData] = useState(initialIndoorRegisterationDataObj);
  const [selectedRadio,setSelectedRadio] = useState('')

  const requestIdRef = useRef(0);

  useEffect(() => {
    // Debounce keystrokes; requestId guard drops out-of-order responses
    const requestId = ++requestIdRef.current;
    const timer = setTimeout(async () => {
      const lowercasedInput = input.toLowerCase().trim();
      try {
        const query = {};
        if (lowercasedInput) {
          query.patientName = lowercasedInput;
        }
        const response = await request('/indoor-registeration-all-detail-list', {
          method: 'GET',
          query: query
        });
        if (requestId !== requestIdRef.current) return; // a newer search superseded this one
        if (response?.success) {
          setPatientData({ loading: false, data: response?.data || [] });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setPatientData({ loading: false, data: [] });
        }
      } catch (error) {
        if (requestId !== requestIdRef.current) return;
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setPatientData({ loading: false, data: [] });
      }
    }, input ? 300 : 0);

    return () => clearTimeout(timer);
  }, [input]);

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleRadioChange = (event) => {
    const { name } = event.target;
    setSelectedRadio(name);
  };
  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Indoor Registeration Search
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      {/* <Stack spacing={0} direction="row" alignItems="center">
          <Radio
            name="auth"
            checked={selectedRadio === 'auth'}
            onChange={handleRadioChange}
          />
          <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Authorised Bill</Typography>
          <Radio
            name="unauth"
            checked={selectedRadio === 'unauth'}
            onChange={handleRadioChange}
          />
          <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>UnAuthorised Bill</Typography>
    
        </Stack> */}
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
        <MuiTextField
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              padding: '0',
              fontSize: '1.4rem'
            },
            '& .MuiOutlinedInput-input': {
              padding: '8px 1.4rem'
            },
            '& .MuiInputLabel-root': {
              fontSize: '1.2rem'
            }
          }}
          label="Search Patient"
          variant="outlined"
          value={input}
          onChange={handleChange}
        />
      </Stack>
      <Table
        sx={{ mt: 0.5 }}
        columns={TABLE_HEADER}
        data={patientData?.data || []}
        onRowClick={(row) => {
          onAdd(row.ipd_no);
          onClose();
          setSelectedRow(true);
        }}
      />
    </>
  );
};
